export default __webpack_public_path__ + "locales/ko-KR/ChangeUserTypeDialog.json?hash=9010cdb4b643b49c31021b22483f5524";